import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d931b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detailBox borderBottom" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "申请事项", -1))
const _hoisted_3 = { style: {"color":"#333"} }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "item-label" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "item-label" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "工商注册地址变更后：", -1))
const _hoisted_12 = { class: "item-value" }

import { message } from "ant-design-vue";
import { reactive,onMounted,watch,withDefaults} from "vue";
import { 
  businessDetailApi,//工商详情
 } from "@/api/businessChange";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { expose, emit: $emit }) {

const props = __props as { update: boolean }


const route = useRoute();
const { id } = route.query;

// 申请事项
const plainOptions = [
  "地址变更",
  "股权变更",
  "名称变更",
  "注册资本变更",
  "营业范围变更",
  "法人、负责人变更",
];
//基本字段定义
const data = reactive({
  check:[],
  businessDetail:{
    ChangeMatters:[],
  },//工商详情
})

//获取工商详情
const getDetail = async ()=>{
  const { Data,Success,Message } = await businessDetailApi({
    Id: id,
  });
  if(Success){
    if(Data){
      data.businessDetail = Data.PageData
      data.check = []
      data.businessDetail.ChangeMatters.forEach(
          item=> {
            data.check.push(item.ChangeCode.toString())
          }
        );
    }
      
    $emit("change-status", {
        buttons: Data?.ActionButtons,
        flowId: Data?.WorkFlowId,
        ApplicationInfo:Data?.ApplicationInfo,
        ApplicationTime:Data?.ApplicationTime
      });
  }else{
    message.warning(Message);
  }
   
}
onMounted(()=>{
  getDetail()
})

watch(
    () => props.update,
    (val, oldval) => {
      if (val != oldval) {
        getDetail()
      }
    }
  );

expose({
  getDetail,
})



return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_checkbox_group, {
      value: _unref(data).check,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).check) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).check, (item) => {
          return (_openBlock(), _createBlock(_component_a_checkbox, {
            key: item,
            value: item,
            label: plainOptions[item -1],
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(plainOptions[item - 1]), 1)
            ]),
            _: 2
          }, 1032, ["value", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).businessDetail.ChangeMatters, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.ChangeCode
      }, [
        (_unref(data).check.includes(item.ChangeCode.toString()))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`${plainOptions[item.ChangeCode -1 ]}前`) + "：", 1),
                _createElementVNode("span", {
                  class: "item-value",
                  title: item.ChangeBefore
                }, _toDisplayString(item.ChangeBefore), 9, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(`${plainOptions[item.ChangeCode -1 ]}后`) + "：", 1),
                _createElementVNode("span", {
                  class: "item-value",
                  title: item.ChangeAfter
                }, _toDisplayString(item.ChangeAfter), 9, _hoisted_9)
              ]),
              (item.ChangeCode == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).businessDetail.BusinessRegisteredAddress), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})